/**
 * @generated SignedSource<<fccdfac94aea2859283affe7ca012f2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageInfoFragment$data = {
  readonly count: number | null | undefined;
  readonly " $fragmentType": "PageInfoFragment";
};
export type PageInfoFragment$key = {
  readonly " $data"?: PageInfoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageInfoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageInfoFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "type": "PageInfo",
  "abstractKey": null
};

(node as any).hash = "3bcc10ea5ed6bfb1cef240f7284a4336";

export default node;
